

export const getDisplayLists = (data) => {
 const splitString = data.split(' ')
 return splitString
}